import { API_BASE_URL } from '../constants';
import { setupInterceptors } from 'services/apiUtils';
import { logoutUsuario, postData } from 'services/servicioPost';
import { IRegistro, LoginRequest } from 'utils/models/interfaces';
import { UsuarioDTO } from 'utils/models/types';
import { limpiarLocalStorage } from 'utils/storage/session';

interface IData {
  Token: string;
  DTOUsuario: UsuarioDTO;
}

const pathReg = '/Usuarios';
const registroPath = `${API_BASE_URL}${pathReg}`;
const pathLogin = '/Usuarios/login';
const loginPath = `${API_BASE_URL}${pathLogin}`;

export const registroUsuario = async (
  objetoRegistrousu: IRegistro,
  setError: (message: string) => void,
  setLoading: (state: boolean) => void
) => {
  return await postData<string>(registroPath, objetoRegistrousu, setError, setLoading);
};

export const loginService = async (
  { Email, Password }: LoginRequest,
  setError: (message: string) => void,
  setLoading: (state: boolean) => void
) => {
  const result = await postData<IData>(loginPath, { Email, Password }, setError, setLoading);
  if (result) {
    const token = result.Token;
    const usuario = armadoUsuarioLogueado(result);
    setupInterceptors();
    localStorage.setItem('token', token);
    localStorage.setItem('usuario', JSON.stringify(usuario));
    localStorage.setItem('usuarioId', JSON.stringify(usuario.Id));
    localStorage.removeItem('tokenExpirado');
    return { token, usuario };
  }
};

export const logoutService = async (
  setError: (message: string) => void,
  setLoading: (state: boolean) => void
): Promise<void> => {
  try {
    await logoutUsuario(setError, setLoading);
  } catch (error) {
    console.error('Error en el logoutService (sesión local limpiada de todas formas):', error);
  } finally {
    limpiarLocalStorage();
  }
};

// Guardo un DTOUsuario no un Usuario
const armadoUsuarioLogueado = (data: IData): UsuarioDTO => {
  const usu = data.DTOUsuario;

  return {
    Id: usu.Id,
    Nombre: usu.Nombre,
    Apellido: usu.Apellido,
    Email: usu.Email,
    Password: '', // No guardar nunca el pass
    Rol: usu.Rol,
    FechaNac: usu.FechaNac,
    DescuentoAsignado: usu.DescuentoAsignado,
    Telefono: usu.Telefono || '-',
    EsElenco: usu.EsElenco,
    EsAlumno: usu.EsAlumno,
    TipoSocio: usu.TipoSocio,
    Talleres: usu.Talleres || [],
  };
};

// limpiarLocalStorage is now in utils/storage/session.ts
